export default __webpack_public_path__ + "assets/images/fbbc9b88e6d2c18071175aa1dbe70c7e.svg";